
import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Spinner } from './Spinner';
import { SpinnerItem } from './SpinnerItem';

class CreateSpinnerToolBehavior extends CreatePhysicalToolBehavior2(Spinner, 'plop') {

    protected createSubject(u: ObjectUpdate) {
        const subject = super.createSubject(u);
        subject.width = 400;
        subject.height = 400;

        for (let i = 0; i < 6; i++) {
            const item = u.create(SpinnerItem);
            item.text = `Item ${i + 1}`;
            subject.add(item);
        }
        return subject;
    }
}

export const spinnerTool = defineToolWithCommonBehaviors({
    id: 'spinnerTool',
    label: 'Spinner',
    category: 'objects',
    // icon: 'deqo://icons/sln/01-interface-essential/spinner',
    // weight: 4000,
    behaviors: [
        CreateSpinnerToolBehavior,
    ]
});
